import './MiniTimeout.css';
import {DisplayConfig} from "../Config";
import {useContext} from "react";
import DisplayParams from "../DisplayParams";
import {t} from "../../i18n";
import {renderTime} from "../../utils";
import './MiniTimeout.css'
import {ActiveTimeout} from "../displayContainer";
import {isAllianceLastTimeout, isRunningMatchTimeout, isT206DependencyTimeout, isT206Timeout} from "../../timeoutUtils";
import {AllianceLastMatchTimeout, T206Timeout} from "../../javaTypes";

export enum MiniTimeoutType {
    BAR = "BAR", EMBED = "EMBED", BANNER = "BANNER", TOP_RIGHT = "TOP_RIGHT", BOTTOM_RIGHT = "BOTTOM_RIGHT"
}

export function useTimeoutRender(timeout: ActiveTimeout) {
    const { matchTiming } = useContext(DisplayParams);
    const standardText = t`Next match expected start:`; // if we want to customize the text
    if (timeout.timeout) {
        if (isT206Timeout(timeout.timeout) && (timeout.timeout as T206Timeout).awaitingScorePost) {
            return {time: "5:00+", text: standardText};
        }
        if (isT206DependencyTimeout(timeout.timeout)) {
            return {time: "8:00+", text: standardText};
        }
        if (isAllianceLastTimeout(timeout.timeout) && (timeout.timeout as AllianceLastMatchTimeout).isFinals) {
            if (timeout.nextMatch) {
                // Don't leak the outcome by showing the timer during the animation! (since timer won't exist if we're done)
                if (timeout.timer.remaining >= 8 * 60) {
                    return undefined;
                }
            } else {
                // Never show - we are done
                return undefined;
            }
        }
        if (isRunningMatchTimeout(timeout.timeout)) {
            return {time: renderTime(timeout.timer.remaining), text: standardText};
        }
        // If not the next match, show the max of the calculated time and the not-yet-applied TBDs
        if ((timeout.nextMatchIndex ?? 0) > 1) {
            if (timeout.timer.remaining < 5 * 60 + 16) {
                return {time: renderTime((matchTiming?.total.add({ seconds: 3 }).total('seconds') || 0) * 2) + "+", text: standardText};
            }
        }
        if ((timeout.nextMatchIndex ?? 0) > 0) {
            if (timeout.timer.remaining < 2 * 60 + 38) {
                return {time: renderTime(matchTiming?.total.add({ seconds: 3 }).total('seconds') || 0) + "+", text: standardText};
            }
        }
        if (timeout.timer.remaining >= 60 * 100) {
            // handle long lunch or overnight breaks
            return {time: "99:59", text: t`Next match starts after break`};
        }
        return {time: renderTime(timeout.timer.remaining), text: standardText};
    }
    return undefined;
}

export default function MiniTimeout({type, config, timeout} : {
    type: MiniTimeoutType,
    config: DisplayConfig,
    timeout: ActiveTimeout
}) {
    const displayParams = useContext(DisplayParams);

    const renderData = useTimeoutRender(timeout);

    if (!renderData) {
        return null;
    }

    if (type === MiniTimeoutType.EMBED) {
        return <div className={"miniTimeout embed"}>
            <div className={"timer"}>
                {renderData.time}
            </div>
        </div>
    }

    if (type === MiniTimeoutType.BANNER || type === MiniTimeoutType.TOP_RIGHT || type === MiniTimeoutType.BOTTOM_RIGHT) {
        return <div className={`miniTimeoutBanner ${config.scoringBarLocation === 'top' ? "vflip" : ""} ${type.toLowerCase().replaceAll("_", "")}`}>
            <div className={`miniTimeout banner`}>
                <div className={"timer"}>
                    {renderData.time}
                </div>
            </div>
            {type === MiniTimeoutType.BOTTOM_RIGHT ? <svg className={"backgroundCallout"} width={"270px"} height={"110px"}>
                <polygon points="0,0 0,110 228,110 270,55 228,0" fill="#495057" stroke="none" />
            </svg> : null}
        </div>
    }

    return <div className={`miniTimeout bar ${displayParams.isFirstChampionship ? 'cmpOffset' : ''}`}>
        <div className={"miniTimeoutText"}>{renderData.text}</div>
        <div className={"timer"}>
            {renderData.time}
        </div>
    </div>
}